// dependencies
import React from "react";

import { Transform } from "@fortawesome/fontawesome-svg-core";
import { IconDefinition } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { ColorShade } from "../../app/Theme";
import Tooltip from "../Tooltip";
// styles
import css from "./Icon.module.scss";

export interface BaseIconProps {
	className?: string;
	size?: "regular" | "small" | "x-small" | "inherit" | "xx-small";
	icon: IconDefinition;
	color?: ColorShade;
	transform?: Transform | string;
	testid?: string;
	useToolTip?: "never" | "always" | "on-truncate";
	toolTipText?: string;
}

const Icon = (props: BaseIconProps) => {
	const {
		className = "",
		size = "regular",
		icon,
		color,
		transform,
		testid,
		useToolTip = "never",
		toolTipText = "",
	} = props;

	const style: React.CSSProperties = {};

	if (color) {
		style.color = `var(--py-${props.color})`;
	}
	return useToolTip === "always" && toolTipText ? (
		<Tooltip message={toolTipText} title={"Top-Level Goal"} placement={"right"} weight={"semi-bold"}>
			<div
				className={`${css.iconContainer} ${size !== "inherit" ? css[size] : null} ${className}`}
				style={style}
				data-testid={testid || `icon-wrapper-${icon.iconName}`}
			>
				<FontAwesomeIcon icon={icon} transform={transform} />
			</div>
		</Tooltip>
	) : (
		<div
			className={`${css.iconContainer} ${size !== "inherit" ? css[size] : null} ${className}`}
			style={style}
			data-testid={testid || `icon-wrapper-${icon.iconName}`}
		>
			<FontAwesomeIcon icon={icon} transform={transform} />
		</div>
	);
};

export default Icon;
